"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PillToggle } from "@/components/ui/controls/PillToggle";
import { useLabels } from "@/lib/labels/LabelsProvider";
import type { LivescoreSport } from "@/views/livescore/utils/livescore";
interface LivescoreSportSelectorProps {
  sport: LivescoreSport;
  onChange: (sport: LivescoreSport) => void;
  sports: LivescoreSport[];
}
export function LivescoreSportSelector(t0) {
  const $ = _c(11);
  const {
    sport,
    onChange,
    sports
  } = t0;
  const labels = useLabels();
  const ls = labels.livescore;
  const t1 = `⚽ ${ls.sports.football}`;
  let t2;
  if ($[0] !== ls.sports.americanFootball || $[1] !== ls.sports.basketball || $[2] !== ls.sports.hockey || $[3] !== ls.sports.tennis || $[4] !== sports || $[5] !== t1) {
    const allOptions = [{
      id: "football" as LivescoreSport,
      label: t1
    }, {
      id: "basketball" as LivescoreSport,
      label: `🏀 ${ls.sports.basketball}`
    }, {
      id: "hockey" as LivescoreSport,
      label: `🏒 ${ls.sports.hockey}`
    }, {
      id: "american-football" as LivescoreSport,
      label: `🏈 ${ls.sports.americanFootball}`
    }, {
      id: "tennis" as LivescoreSport,
      label: `🎾 ${ls.sports.tennis}`
    }];
    t2 = allOptions.filter(opt => sports.includes(opt.id));
    $[0] = ls.sports.americanFootball;
    $[1] = ls.sports.basketball;
    $[2] = ls.sports.hockey;
    $[3] = ls.sports.tennis;
    $[4] = sports;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const options = t2;
  let t3;
  if ($[7] !== onChange || $[8] !== options || $[9] !== sport) {
    t3 = <PillToggle options={options} activeId={sport} onChange={onChange} size="md" />;
    $[7] = onChange;
    $[8] = options;
    $[9] = sport;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}